var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FC18A76A-669D-4ABF-8C94-D5094DE9E55D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Kolo---Final---Internas",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Option-1.2-P\\xE1gina-Interna---Orden-de-compra",
    transform: "translate(-386.000000, -540.000000)",
    fill: "#226095"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/dropdown-Copy",
    transform: "translate(404.000000, 558.000000) rotate(-180.000000) translate(-404.000000, -558.000000) translate(386.000000, 540.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6935774,12.2869449 L16.6943041,12.2876717 L22.207134,17.8074622 C22.481408,18.0820824 22.5612437,18.4773923 22.4466602,18.8222735 C22.466256,19.0939034 22.3749289,19.3729631 22.1707436,19.5846702 L16.7549193,25.2000014 C16.375299,25.5936061 15.7484763,25.6049427 15.3548716,25.2253224 L15.3541327,25.224609 C14.9603944,24.8440707 14.9493699,24.2165014 15.3294996,23.8223686 L20.282935,18.6852158 L15.2931092,13.6900078 C14.906149,13.302559 14.9062193,12.6748769 15.2932661,12.2875148 C15.679794,11.9006722 16.3067348,11.900417 16.6935774,12.2869449 Z",
    id: "Combined-Shape-Copy-5",
    transform: "translate(18.750122, 18.750000) rotate(-270.000000) translate(-18.750122, -18.750000) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.cb9750d3313b57cae1b14b98fc0e7bc3.svg";
export { ForwardRef as ReactComponent };